var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJournal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 44,
    viewBox: "0 0 45 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.3877 31.3633C15.1989 31.3633 14.293 31.0553 13.6699 30.4395C13.054 29.8307 12.7461 28.9355 12.7461 27.7539V15.4756C12.7461 14.3011 13.054 13.4059 13.6699 12.79C14.293 12.1742 15.1989 11.8662 16.3877 11.8662H27.6992L25.3145 14.2617H16.5918C16.1191 14.2617 15.7575 14.3835 15.5068 14.627C15.2562 14.8704 15.1309 15.2393 15.1309 15.7334V27.5176C15.1309 28.0117 15.2562 28.3805 15.5068 28.624C15.7575 28.8604 16.1191 28.9785 16.5918 28.9785H28.6338C28.9847 28.9785 29.2747 28.8604 29.5039 28.624C29.7331 28.3805 29.8477 28.0117 29.8477 27.5176V18.8916L32.2432 16.5068V27.7539C32.2432 28.9355 31.9424 29.8307 31.3408 30.4395C30.7464 31.0553 29.9085 31.3633 28.8271 31.3633H16.3877ZM20.5557 24.0371C20.4196 24.0872 20.2907 24.055 20.1689 23.9404C20.0472 23.8258 20.0186 23.6969 20.083 23.5537L21.0498 21.3516L30.6855 11.7158L32.4473 13.4668L22.8115 23.1025L20.5557 24.0371ZM33.2852 12.6396L31.5234 10.8672L32.2432 10.1475C32.4652 9.93262 32.7194 9.81445 33.0059 9.79297C33.2995 9.76432 33.543 9.8431 33.7363 10.0293L34.0479 10.3516C34.2699 10.5664 34.3773 10.8171 34.3701 11.1035C34.363 11.39 34.2448 11.6514 34.0156 11.8877L33.2852 12.6396Z",
    fill: "#DBF0F9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJournal);
export default __webpack_public_path__ + "static/media/journal.43feb118679a5d113ba20550076cf6ce.svg";
export { ForwardRef as ReactComponent };